module.exports = __webpack_public_path__ + "img/logo-text_white@2x.d8ce171b.png";